module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-primary",
    attrs: {
      "id": "aprovacao"
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": this.$router.currentRoute.name === 'proposta-visualiza'
    }
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Aprovação"), (_vm.aprovacao.ds_codigo_projeto_erp) ? _c('span', [_vm._v(" do projeto "), _c('b', [_vm._v(_vm._s(_vm.aprovacao.ds_codigo_projeto_erp))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "cmptDocPreparationForm",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('legend', [_vm._v("Datas")]), _vm._v(" "), _c('dl', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('data proposta')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data da Proposta")]), _vm._v(" "), _c('span', {
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled"
    }
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.propsAprovacao.dt_proposta, "L")))])])]), _vm._v(" "), _c('dl', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('data análise')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data de análise")]), _vm._v(" "), _c('span', {
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled"
    }
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.propsAprovacao.dt_analise, "L")))])])]), _vm._v(" "), _c('dl', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('data deferimento')
    },
    attrs: {
      "uib-tooltip": "Data de deferimento"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data de deferimento")]), _vm._v(" "), _c('span', {
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled"
    }
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.propsAprovacao.dt_deferimento, "L")))])])]), _vm._v(" "), _c('dl', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data de assinatura do convênio")]), _vm._v(" "), _c('span', {
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled"
    }
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.propsAprovacao.dt_assinatura_convenio, "L")))])])]), _vm._v(" "), _c('dl', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('data vigência')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data de Vigência do Projeto")]), _vm._v(" "), _c('span', {
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled"
    }
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.propsAprovacao.dt_data_vigencia, "L")))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("Documentos da Formalização")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('upload-documentos-php-novo', {
    attrs: {
      "propDocumentos": this.propsAprovacao.documentos.formalizacao,
      "documentTypes": _vm.tiposDocumentos,
      "documentosObrigatorios": '',
      "local-uso": 'TODOS',
      "faseProposta": _vm.propsAprovacao.ds_fase
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v(" Ficha de Auto Verificação")]), _vm._v(" "), _vm._l((_vm.perguntasFAV), function(item) {
    return _c('div', [(item.nivel === 3) ? _c('label', {
      staticClass: "control-label col-md-10",
      class: 'favNivel' + item.nivel
    }, [_vm._v(_vm._s(item.numero) + " " + _vm._s(item.pergunta))]) : _vm._e(), _vm._v(" "), (item.nivel !== 3) ? _c('span', {
      staticClass: "control-label col-md-10",
      class: 'favNivel' + item.nivel
    }, [_vm._v(_vm._s(item.pergunta))]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
      }],
      staticClass: "col-md-1",
      staticStyle: {
        "alignment": "left"
      },
      attrs: {
        "title": '<h5>Pergunta <span class=\'realce\'>' + item.numero + '</span></h5>'
      }
    }, [(item.nivel === 3) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.resposta),
        expression: "item.resposta"
      }],
      staticClass: "form-control respostaFav",
      attrs: {
        "disabled": "disabled"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "resposta", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.respostaFAV), function(opcao) {
      return _c('option', {
        domProps: {
          "value": opcao.valor
        }
      }, [_vm._v(_vm._s(opcao.resposta))])
    }), 0) : _vm._e()])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("Decisões")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('aprovacao')
    },
    attrs: {
      "uib-tooltip": "Decisões da preparação de documentos"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propsAprovacao.resultadoAprovacao),
      expression: "propsAprovacao.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "aprovacao",
      "value": "APROVAR"
    },
    domProps: {
      "checked": _vm._q(_vm.propsAprovacao.resultadoAprovacao, "APROVAR")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.propsAprovacao, "resultadoAprovacao", "APROVAR")
      }, _vm.verificaDecisao]
    }
  }), _vm._v("\n                    Aprovar o Projeto (APR)\n                    "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propsAprovacao.resultadoAprovacao),
      expression: "propsAprovacao.resultadoAprovacao"
    }],
    attrs: {
      "type": "radio",
      "name": "aprovacao",
      "value": "VOLTAR_ANALISE",
      "id": "msgDef"
    },
    domProps: {
      "checked": _vm._q(_vm.propsAprovacao.resultadoAprovacao, "VOLTAR_ANALISE")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.propsAprovacao, "resultadoAprovacao", "VOLTAR_ANALISE")
      }, _vm.verificaDecisao]
    }
  }), _vm._v("\n                    Devolver para Reanálise\n                    "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propsAprovacao.resultadoAprovacao),
      expression: "propsAprovacao.resultadoAprovacao"
    }],
    attrs: {
      "type": "radio",
      "name": "aprovacao",
      "value": "VOLTAR_FORMALIZACAO",
      "id": "formalizacao"
    },
    domProps: {
      "checked": _vm._q(_vm.propsAprovacao.resultadoAprovacao, "VOLTAR_FORMALIZACAO")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.propsAprovacao, "resultadoAprovacao", "VOLTAR_FORMALIZACAO")
      }, _vm.verificaDecisao]
    }
  }), _vm._v("\n                    Devolver para Formalização\n                    "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propsAprovacao.resultadoAprovacao),
      expression: "propsAprovacao.resultadoAprovacao"
    }],
    attrs: {
      "type": "radio",
      "name": "aprovacao",
      "value": "CANCELAR_PROJETO",
      "id": "cancelar"
    },
    domProps: {
      "checked": _vm._q(_vm.propsAprovacao.resultadoAprovacao, "CANCELAR_PROJETO")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.propsAprovacao, "resultadoAprovacao", "CANCELAR_PROJETO")
      }, _vm.verificaDecisao]
    }
  }), _vm._v("\n                    Cancelar o Projeto (CAN)\n                    "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), (_vm.errors.first('aprovacao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('aprovacao')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.propsAprovacao.resultadoAprovacao === 'VOLTAR_FORMALIZACAO') ? _c('div', {
    staticClass: "form-group full col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('justificativa')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propsAprovacao.observacao),
      expression: "propsAprovacao.observacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "justificativa"
    },
    domProps: {
      "value": (_vm.propsAprovacao.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propsAprovacao, "observacao", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.propsAprovacao.resultadoAprovacao === 'VOLTAR_ANALISE' || _vm.propsAprovacao.resultadoAprovacao === 'CANCELAR_PROJETO') ? _c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('anexo')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Anexo obrigatório")]), _vm._v(" "), _c('upload-documentos-php-novo', {
    attrs: {
      "propDocumentos": _vm.aprovacaoDocumentos,
      "documentTypes": '',
      "documentosObrigatorios": '',
      "local-uso": 'APROVACAO_PROJETO_RESTRICAO'
    }
  }), _vm._v(" "), (_vm.errors.first('anexo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('anexo')))]) : _vm._e()], 1) : _vm._e()])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6ca4b060!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/validação/proposta/aprovacao.vue
// module id = 2004
// module chunks = 1